import type { CmsLink, CmsLinkList } from '@omnia/ui/src/lib/cms/types'
import type { CmsImageWithFocalPoint } from '@omnia/ui/src/lib/cms/types/cmsImageWithFocalPoint'
import type { CmsStringArray } from '@omnia/ui/src/lib/cms/types/cmsStringArray'

export class SiteLogoPropsApi {
    image: CmsImageWithFocalPoint
}

export class CinemaTabsPropsApi {
    /**
     * Default: "Cinemas"
     */
    activeTabLabel: string = 'Cinemas'

    /**
     * Label and link for the alternative site tab.
     *
     * Default: "Home Cinema" (https://homecinema.curzon.com/)
     */
    alternativeTabLink: CmsLink
}

export class NavigationPropsApi {
    mainNavigation: CmsLinkList
    mobileNavigationFooterTitle: string
    mobileNavigationFooterLinks: CmsLinkList
}

// SortOrder = 5
export class SearchPropsApi {
    /**
     * Default: "Search for a Film, Venue or Event"
     */
    placeholderText: string = 'Search for a Film, Venue or Event'

    /**
     * Default: "No results found."
     */
    noResultsFoundMessage: string = 'No results found.'
}

// SortOrder = 6
export class PreferredCinemaPromptPropsApi {
    /**
     * Default: "Choose your preferred cinemas"
     */
    promptLabel: string = 'Choose your preferred cinemas'

    /**
     * Rules of page locations this pop up does not appear in.
     * Examples:
     *  - / for homepage or for all pages
     *  - /cinemas/
     *  - /cinemas/
     *  - /cinemas/cinemaName/
     *
     *  This can take a wildcard option such as an *
     * */
    excludePreferredCinemaPopupFrom: CmsStringArray

    /**
     * Period on how long should this tooltip re-appear after a user closes it.
     */
    noOfDays: number
}

// SortOrder = 4
export class QuickBookPropsApi {
    /**
     * The main heading for the component.
     * Default: "Quick navigator"
     */
    headingLabel: string = 'Quick navigator'

    /**
     * The label shown on the action button.
     * Default: "Search"
     */
    actionButtonLabel: string = 'Search'

    /**
     * The label shown on the reset button.
     * Default: "Reset"
     */
    resetButtonLabel: string = 'Reset'
}
